// generated by the plop

export class GetTypesService {
  static type = '[typesService] SetExampleField';

}
